import ymaps from 'ymaps';


ymaps.load('https://api-maps.yandex.ru/2.1/?apikey=725e3a06-26bc-4012-9536-816779506947&lang=ru_RU')
   .then(maps => {
      // Создание экземпляра карты.

      const myMap = new maps.Map('map', {
         center: address[0].items[0].center,
         zoom: 17,
         controls: []
      });

      for (var i = 0, l = address.length; i < l; i++) {
         createMenuGroup(address[i]);
      }

      function createMenuGroup(group) {
         // Коллекция для геообъектов группы.
         let collection = new maps.GeoObjectCollection(null, { preset: group.style });
         // Контейнер для подменю.
         let submenu = '';

         // Добавляем коллекцию на карту.
         myMap.geoObjects.add(collection);
         for (var j = 0, m = group.items.length; j < m; j++) {
            createSubMenu(group.items[j], collection, submenu);
         }
      }


      function createSubMenu(item, collection, submenu) {
         // Пункт подменю.
         var submenuItem = $('<li>' +
            '<p class="name"><a href="#" class="clickMap">' + item.name + '</a></p>' +
            '<p class="timeWork">' + item.timeWork + '</p>' +
            '<p class="phone"><a href="tel:' + item.phone + '">' + item.phone + '</a></p>' +
            '<p class="address">' + item.address + '</p>' +
            '</li>'),
            // Создаем метку.
            placemark = new maps.Placemark(item.center, {
               balloonContent: item.address
            }, {
               //preset: 'islands#icon',
               //iconColor: '#ecb731',
               iconLayout: 'default#image',
               iconImageSize: [50, 50],
               iconImageOffset: [-24, -48],
               iconContentOffset: [15, 15],
               // Макет содержимого.
               iconImageHref: '/themes/project/assets/images/icons/ymap-marker.svg'
            });


         // Добавляем метку в коллекцию.
         collection.add(placemark);
         // Добавляем пункт в подменю.
         submenuItem
            .appendTo(submenu)
            // При клике по пункту подменю открываем/закрываем баллун у метки.
            .find('a[class="clickMap"]')
            .bind('click', function () {
               if (!placemark.balloon.isOpen()) {
                  placemark.balloon.open();
               } else {
                  placemark.balloon.close();
               }
               return false;
            });
      }

      // Выставляем масштаб карты чтобы были видны все группы.
      if (address.length > 1) myMap.setBounds(myMap.geoObjects.getBounds());
   });




